import globalStorePlugin from '~~/common/vue/store/global';
import userStorePlugin from '~~/common/vue/store/user';
import notificationsStorePlugin from '~~/common/vue/components/notifications/store';
import { fetchTreeData } from '~/api';

export const plugins = [
  globalStorePlugin,
  userStorePlugin,
  notificationsStorePlugin,
];

export const state = () => ({
  confirmEmail: '',
  mocked: false,
  notificationBannerVisible: false,
  notificationPopupVisible: false,
  personalCounterOpen: false,
  treeCount: 0,
  treeRate: 0,
});

export const mutations = {
  setMocked(st, mocked) {
    st.mocked = mocked;
  },
  setTreeCount(st, treeCount) {
    st.treeCount = treeCount;
  },
  setTreeRate(st, treeRate) {
    st.treeRate = treeRate;
  },
  setPersonalCounterOpen(st, open) {
    st.personalCounterOpen = open;
  },
};

export const actions = {
  nuxtServerInit({ commit, dispatch }, context) {
    dispatch('global/nuxtServerInit', context);
    dispatch('user/nuxtServerInit', context);
    dispatch('notifications/nuxtServerInit', context);
    const { req, query } = context;
    const { treeCounter } = req || {};
    if (treeCounter) {
      commit('setTreeCount', treeCounter.count);
      commit('setTreeRate', treeCounter.rate);
    }
    commit('setMocked', !!query.mocked);
  },
  nuxtClientInit({ dispatch }, context) {
    dispatch('user/nuxtClientInit', context);
  },
  async fetchTreeData({ commit, state: { mocked, treeCount, treeRate } }) {
    if (treeCount > 0 && treeRate > 0) {
      return;
    }
    const { count, rate } = await fetchTreeData(this.$config.apiUrl, mocked);
    commit('setTreeCount', count);
    commit('setTreeRate', rate);
  },
  hidePopups({ commit }) {
    commit('notifications/setPopupVisible', false);
  },
};
